import { createNode } from '@opten/dom/create-node';
import { getSelectorElementFromElement } from '@opten/dom/get-selector-element-from-element';

export type MenuPositionX = 'before' | 'after';

export type MenuPositionY = 'above' | 'below';

export class Menu {
	readonly connectTo: HTMLElement;
	readonly xPosition: MenuPositionX;
	readonly yPosition: MenuPositionY;
	readonly overlapTrigger: boolean;
	readonly lazyContent: boolean;
	readonly backdropClassName?: string;
	readonly hasBackdrop?: boolean;
	portalElement: HTMLElement;

	constructor(public element: HTMLElement) {
		this.xPosition = this.element.hasAttribute('data-x-position')
			? (this.element.getAttribute('data-x-position') as MenuPositionX)
			: 'after';
		this.yPosition = this.element.hasAttribute('data-y-position')
			? (this.element.getAttribute('data-y-position') as MenuPositionY)
			: 'below';
		this.overlapTrigger = this.element.hasAttribute('data-overlap-trigger')
			? this.element.getAttribute('data-overlap-trigger') === 'true'
			: false;
		this.connectTo = this.element.hasAttribute('data-connect-to')
			? getSelectorElementFromElement(this.element, 'data-connect-to', false)
			: null;
		this.lazyContent = this.element.hasAttribute('data-lazy-content')
			? this.element.getAttribute('data-lazy-content') === 'true'
			: false;
		this.backdropClassName = this.element.hasAttribute('data-backdrop-class')
			? this.element.getAttribute('data-backdrop-class')
			: null;
		this.hasBackdrop = this.element.hasAttribute('data-has-backdrop')
			? this.element.getAttribute('data-has-backdrop') === 'true'
			: true;

		this.portalElement = createNode(
			`<div class="c-menu__panel">${this.getMenuContent()}</div>`
		);
	}

	updatePortal() {
		this.portalElement.innerHTML = this.getMenuContent();
	}

	getMenuContent() {
		return `<div class="c-menu__content">${this.element.innerHTML}</div>`;
	}
}
